import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-seq-total-dialog',
  templateUrl: './seq-total-dialog.component.html',
  styleUrls: ['./seq-total-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeqTotalDialogComponent {
  constructor(private dialog: MatDialog) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
